import { render, staticRenderFns } from "./Tinymce.vue?vue&type=template&id=6c90b897"
import script from "./Tinymce.vue?vue&type=script&lang=js"
export * from "./Tinymce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports